import PatientDetailsView from "./PatientDetailsView";
import React, {useContext, useState} from "react";
import {Patient} from "../../api-client";
import {Button, Modal} from "antd";
import {FormattedMessage} from "react-intl";
import {isMobileOnly} from "react-device-detect";
import {CloseOutlined} from "@ant-design/icons";
import {ExitPromptContext} from "../../context/ExitPromptContext";
import {DentobookApplicationContext} from "../../context/DentobookApplicationContext";
import {getPatientFormComponent} from "../../utils/patientUtils";

interface PatientDetailsItemProps {
    patient: Patient;
    setPatient: Function;
    editMode: boolean;
    setEditMode: Function;
}

const PatientDetailsItem = ({patient, setPatient, editMode, setEditMode}: PatientDetailsItemProps) => {

    const { userOrganization} = React.useContext(DentobookApplicationContext);
    const {setFormDirty} = useContext(ExitPromptContext);

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const initialPatient = {...patient};

    const handleOk = () => {
        setFormDirty(false);
        setIsModalOpen(false);
        setPatient(initialPatient);
        setEditMode(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const footer = <div className="modal-btn-wrapper">
        <Button className="modal-btn" onClick={handleCancel}>
            {<FormattedMessage id="cancel"/>}
        </Button>
        <Button className="modal-btn" type="primary" onClick={handleOk}
        >
            {<FormattedMessage id="confirm"/>}
        </Button>
    </div>;

    return (
        <>
            <Modal
                transitionName=""
                className="dentobook-modal"
                footer={footer}
                title={<FormattedMessage id="edit_patient"/>}
                closeIcon={<CloseOutlined className={'icon-24px'} onClick={handleCancel}/>}
                open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <h3 className={"dentobook-content font-weight-500 font-24 text-align-center " + (isMobileOnly ? "mt-112" : "")}><FormattedMessage
                    id="unsaved_changes"/></h3>
            </Modal>
            {
                editMode ?
                    React.createElement(
                        getPatientFormComponent(userOrganization),
                        {
                            mode: 2,
                            setEditMode,
                            openModal: () => setIsModalOpen(true),
                            patient,
                            setPatient,
                        }
                    )
                    :
                    <PatientDetailsView patient={patient} setEditMode={setEditMode}/>
            }
        </>
    );
};

export default PatientDetailsItem;